/* eslint-disable react/prop-types */
import React, { useState } from "react";
import "./tooltip.css";

const Tooltip = (props) => {
  let timeout;
  const [active, setActive] = useState(false);

  const showTip = () => {
    timeout = setTimeout(() => {
      setActive(true);
    }, props.delay || 400);
  };

  const hideTip = () => {
    clearInterval(timeout);
    setActive(false);
  };

  return (
    <div
     
      className="Tooltip-Wrapper"
      // When to show the tooltip
      onMouseEnter={showTip}
      onMouseLeave={hideTip}
    >
      {/* Wrapping */}
      {props.children}
      {active && (
         <div style={{width: '120px', padding: '5px'}} className={`Tooltip-Tip ${props.direction || "top"}`}>
          {/* Content */}
          <span style={{textAlign: 'center', display: 'block', wordWrap: 'break-word', whiteSpace: 'normal', fontSize: '12px'}}> {props.content}</span>
        </div>
      )}
    </div>
  );
};

export default Tooltip;
